export default {
  LOAD_LIST(state, data) {
    state.listMediumProtocol = data
  },
  PREPARE_TO_EDIT(state, data) {
    state.mediumProtocol = data
  },
}
